import type { FC } from "react";

import { DataGroupsSearchForm } from "src/app/features/DataGroup/components/forms/DataGroupsSearchForm";
import { DataGroupSearchTerminalButton } from "src/app/features/DataGroup/components/SearchTerminalButton";
import { DataGroupsTable } from "src/app/features/DataGroup/components/tables/DataGroupsTable";
import type { DataGroupList } from "src/app/features/DataGroup/types/DataGroupList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const DataGroupsPage: FC<NoneOwnProps> = () => {
    const table = <DataGroupsTable />;
    const searchForm = <DataGroupsSearchForm />;
    const hasAccess = canAccess(ResourceName.DATA_GROUPS, "canRead");

    // TODO if user deletes a DG and it is the one currently selected, then current selected DG must be removed
    // setNextDG(null).
    return (
        <PageLayout name="dataGroups_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.dataGroups" />
                    <ResourceManager<DataGroupList>
                        useDataGroup={false}
                        dataMapperKey="dataGroupTableData"
                        resource={ResourceName.DATA_GROUPS}
                        table={table}
                        searchForm={searchForm}
                        customActions={[
                            {
                                action: <DataGroupSearchTerminalButton />,
                                permission: "searchTerm",
                            },
                        ]}
                        actions={[Actions.ADD, Actions.FORM_COPY, Actions.DELETE]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
